import { jsx, jsxs } from "react/jsx-runtime";
import { TabbedContainer } from "../ui/tabbed-container.js";
import { renderBlock } from "./block-registry.js";
import { Layout, File, Calendar, Clock, Zap, Target, Award, TrendingUp, ThumbsUp, Tag, Shield, MessageSquare, Mail, BellRing, Bell, BarChart, FileText, List, Grid, Search, Home, Bookmark, Star, Settings, Heart, Trophy, Activity, Reply, MessageCircle, Users, User } from "lucide-react";
const getIconComponent = (iconName) => {
  const iconMap = {
    "User": User,
    "Users": Users,
    "MessageCircle": MessageCircle,
    "Reply": Reply,
    "Activity": Activity,
    "Trophy": Trophy,
    "Heart": Heart,
    "Settings": Settings,
    "Star": Star,
    "Bookmark": Bookmark,
    "Home": Home,
    "Search": Search,
    "Layout": Layout,
    "Grid": Grid,
    "List": List,
    "FileText": FileText,
    "BarChart": BarChart,
    "Bell": Bell,
    "BellRing": BellRing,
    "Mail": Mail,
    "MessageSquare": MessageSquare,
    "Shield": Shield,
    "Tag": Tag,
    "ThumbsUp": ThumbsUp,
    "TrendingUp": TrendingUp,
    "Award": Award,
    "Target": Target,
    "Zap": Zap,
    "Clock": Clock,
    "Calendar": Calendar,
    "File": File
  };
  return iconMap[iconName] || Layout;
};
const TabbedContainerBlock = ({
  config = {},
  contextData = {},
  className = "",
  ...otherProps
}) => {
  const mergedContextData = {
    ...contextData,
    ...otherProps,
    ...config
  };
  const blockConfig = { ...config, ...mergedContextData };
  const {
    tab_areas = [],
    container_mode = "tabs",
    container_variant = "default",
    container_orientation = "horizontal",
    default_tab,
    url_param = "tab"
  } = blockConfig;
  if (!tab_areas || tab_areas.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: "text-center py-8 text-muted-foreground", children: /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx(Layout, { className: "w-8 h-8 mx-auto text-muted-foreground/50" }),
      /* @__PURE__ */ jsx("p", { className: "text-sm", children: "No tabs configured for this container" }),
      /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground/70", children: "Configure tabs in the layout customizer" })
    ] }) });
  }
  const normalizeBlock = (block) => {
    if (typeof block === "string") {
      return { id: block };
    }
    return block;
  };
  const renderTabBlocks = (blocks) => {
    if (!blocks || blocks.length === 0) {
      return /* @__PURE__ */ jsx("div", { className: "text-sm text-muted-foreground", children: "No content" });
    }
    return /* @__PURE__ */ jsx("div", { className: "space-y-4", children: blocks.map((block, index) => {
      const normalizedBlock = normalizeBlock(block);
      return renderBlock(
        normalizedBlock.id,
        { ...mergedContextData, ...normalizedBlock.config },
        `tab-block-${index}`
      );
    }) });
  };
  const tabs = tab_areas.filter((tab) => tab.enabled !== false).map((tab) => ({
    id: tab.slug || tab.id,
    label: tab.label,
    icon: getIconComponent(tab.icon),
    component: () => renderTabBlocks(tab.blocks)
  }));
  return /* @__PURE__ */ jsx(
    TabbedContainer,
    {
      tabs,
      defaultTab: default_tab,
      urlParam: url_param,
      mode: container_mode,
      orientation: container_orientation,
      variant: container_variant,
      className
    }
  );
};
export {
  TabbedContainerBlock,
  TabbedContainerBlock as default
};
//# sourceMappingURL=tabbed-container-block.js.map
